import { RecShapeIfc } from './RecShapeIfc';
import { BitBoardEntity } from '../utils/BitBoardEntity';

export class RecShape implements RecShapeIfc{
    names:Array<string>;
    types:Array<string>;
    
    nameToId:Map<string, number>;
    entity:BitBoardEntity;
    
    data:Array<Array<any>>;
    
    private static generateNames( types:Array<string> ):Array<string>{
        var names:Array<string> = new Array<string>();

        for( let i:number = 0; i < types.length; i++ ){
            names[i] = types[i] + "_" + i;
        }

        return names;
    }
    constructor( types:Array<string>, names:Array<string> = null ) 
    {
        this.types = types;
        if ( names == null ) {
            this.names = RecShape.generateNames( types );
        }else {
            this.names = names;		
        }
        this.nameToId = new Map<string, number>();
        var i:number = 0;
        this.entity = new BitBoardEntity( 0, 0 );
        for (let name of names){
            this.nameToId.set( name, i );
            this.entity.setPosition( i );
            i++;
        }
        this.initData();
        
    }
    
    private initData():void {
        let i:number = 0;
        this.data = new Array();
        for (let name of this.names){
            if ( this.types[i] == "string" || this.types[i] == "String") {
                this.data[i] = new Array<string>();
            }
            if ( this.types[i] == "boolean" || this.types[i] == "Boolean" ) {
                this.data[i] = new Array<boolean>();
            }
            if ( this.types[i] == "int" ) {
                this.data[i] = new Array<number>();
            }
            if ( this.types[i] == "number" || this.types[i] == "Number" ) {
                this.data[i] = new Array<number>();
            }
            i++;
        }
    }
    public getType( position:number ):string{
        return this.types[ position ];
    }
    
    public getSize():number{
        return this.names.length;
    }
    
    public getFieldTypes():Array<string>{
        return this.types;
    }
    public getNames():Array<string>{
        return this.names;
    }
    
    public getColId( name:string ):number{
        return this.nameToId.get( name );
    }
    
    public getCellsAsBitBoard():BitBoardEntity{
        return this.entity;
    }
    
    public reset():void{
        this.initData();
    }
    
    public remove( id:number ):void{
        for ( let i = 0; i < this.getSize(); i++) {
            this.data[i].splice( id, 1);
        }
    }
    
    public getIntAt( id:number, position:number ):number{
        return this.data[position][ id ];
    }
    
    public getStringAt( id:number, position:number ):string { 
        return this.data[position][ id ];
    }
    
    public getNumberAt( id:number, position:number ):number{
        return this.data[position][ id ];
    }
    
    public getBooleanAt( id:number, position:number ):boolean{
        return this.data[position][ id ];
    }
    
    public getIntByName( id:number, name:string ):number{
        return this.getIntAt( id, this.getColId( name ) );
    }
    public getStringByName( id:number, name:string ):string{
        return this.getStringAt( id, this.getColId( name ) );
    }
    public getNumberByName( id:number, name:string ):number{
        return this.getNumberAt( id, this.getColId( name ) );
    }
    public getBooleanByName( id:number, name:string ):boolean{
        return this.getBooleanAt( id, this.getColId( name ) );
    }
    
    public setIntAt( id:number, position:number, value:number ):void{
        this.data[position][id] = value;
    }
    public setStringAt( id:number, position:number, value:string ):void{
        this.data[position][id] = value;	
    }
    public setNumberAt( id:number, position:number, value:number):void{
        this.data[position][id] = value;
    }
    public setBooleanAt( id:number, position:number, value:boolean ):void{
        this.data[position][id] = value;
    }
    
    public setIntByName( id:number, name:string, value:number ):void{
        this.data[ this.getColId( name )][id] = value;	
    }
    public setStringByName( id:number, name:string, value:string ):void{
        this.data[ this.getColId( name )][id] = value;		
    }
    public setNumberByName( id:number, name:string, value:number):void{
        this.data[ this.getColId( name )][id] = value;	
    }
    public setBooleanByName( id:number, name:string, value:boolean ):void{
        this.data[ this.getColId( name )][id] = value;	
    }

}